module.exports = __webpack_public_path__ + "img/Selaginella_moellendorffii.49f3d4c7.jpg";